<template>
  <div class='page page__list'>
    <search-bar
      @search="onSearch"
      name="pr_code,pr_detail,si_vendname,si_code"
      placeholder="输入物料、供应商、单号进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.sid_id"
        :to="'/purchase/sample_inquiry/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.sid_prodname}}</p>
          <p class="list-item-muted">{{item.sid_prodcode}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.si_code}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.si_status!='已审核'}"
          >{{item.si_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/sample/sampleInquiry/list",
      params: {
        mode: "DETAIL",
        number: 1,
        size: 10,
      },
      filters: [
        {
          type: "date",
          name: "si_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              mode: "DETAIL"
            },
            {
              value: 1,
              label: "待审核",
              condition: "si_status='未审核'"
            },
            {
              value: 2,
              label: "待报价",
              condition: "si_status='已审核'"
            },
            {
              value: 3,
              label: "待采纳",
              // condition: "si_statuscode = \'AUDITED\'"
              condition: "si_statuscode = 'AUDITED'",
              mode: "20"
            },
            {
              value: 4,
              label: "已采纳",
              // condition: "si_statuscode = \'AUDITED\' and  sid_id in(select ipd_sidid from sample_inquiry_price_detail where ipd_status='ACCEPT')"
              condition: "si_statuscode = 'AUDITED' and  sid_id in(select ipd_sidid from sample_inquiry_price_detail where ipd_status='ACCEPT')",
              mode: "30"
            },
            {
              value: 5,
              label: "未采纳",
              // condition: "si_statuscode = \'AUDITED\' and  sid_id in(select ipd_sidid from sample_inquiry_price_detail where ipd_status='REFUSE')"
              condition: "si_statuscode = 'AUDITED' and  sid_id in(select ipd_sidid from sample_inquiry_price_detail where ipd_status='REFUSE')",
              mode: "40"
            },
          ]
        }
      ]
    }
  }
}
</script>